import {
    AfterViewInit,
    Component,
    Input,
    OnInit,
    ChangeDetectionStrategy
} from "@angular/core";

@Component({
    selector: "rask-gauge-chart",
    templateUrl: "./gauge-chart.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./gauge-chart.component.scss"]
})
export class GaugeChartComponent implements OnInit, AfterViewInit {
    @Input() index: number;
    @Input() value: number;

    gaugeId: string;

    protected percent = 0;
    protected flooredValue = 0;

    ngOnInit(): void {
        this.gaugeId = `#gauge_${this.index}`;
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            const val = this.value > 200 ? 200 : this.value;
            this.percent = Math.floor(val / 2);
            this.flooredValue = Math.floor(this.value);
        }, 500);
    }
}
